module.exports = __webpack_public_path__ + "static/4-e5e51f591c9fd64de214923c805d0fe5.jpg";